'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchInput = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

var _helpers = require('../helpers');

var _SearchInputStyle = require('./SearchInput.style.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// creating the search input component
var SearchInput = function SearchInput(props) {
  var className = props.className,
      focused = props.focused,
      value = props.value,
      onChange = props.onChange,
      onClear = props.onClear,
      rest = (0, _objectWithoutProperties3.default)(props, ['className', 'focused', 'value', 'onChange', 'onClear']);


  return _react2.default.createElement(
    'div',
    {
      className: className },
    _react2.default.createElement(
      'div',
      {
        className: 'icons' },
      _react2.default.createElement('i', { className: 'fa fa-search fa-1x' })
    ),
    _react2.default.createElement('input', (0, _extends3.default)({}, rest, {
      onChange: onChange,
      value: value
    })),
    onClear && value && value.length > 0 && _react2.default.createElement(
      'div',
      {
        className: 'icons clear',
        onClick: onClear
      },
      _react2.default.createElement('i', { className: 'fa fa-times' })
    )
  );
};

exports.SearchInput = SearchInput;
SearchInput.propTypes = {
  /**
   * For adding a custom class name
   */
  className: _propTypes2.default.string,

  /**
   * whether the field is in focus (passed automatically through withFocus)
   */
  focused: _propTypes2.default.bool,

  /**
   * Function to handle search input change
   */
  onChange: _propTypes2.default.func,

  /**
   * onClear function called when the x button is pressed
   */
  onClear: _propTypes2.default.func,

  /**
   * Input placeholder value
   */
  placeholder: _propTypes2.default.string,

  /**
   * Value for the search input
   */
  value: _propTypes2.default.string
};
SearchInput.defaultProps = {
  placeholder: 'Search'
};

// exporting the search input component
exports.default = (0, _helpers.withFocus)((0, _glamorous2.default)(SearchInput)(_SearchInputStyle.defaultStyle, _SearchInputStyle.mapPropsAndThemeToStyle));


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/form/SearchInput/SearchInput.js
// module id = 482
// module chunks = 0